<!--
/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software: you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation, either
 * version 3 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with OrangeHRM.
 * If not, see <https://www.gnu.org/licenses/>.
 */
 -->

<!-- Ensibuuko: punch-in GPS cell (links to Google Maps) -->
<template>
  <div class="oxd-table-card-cell">
    <div v-show="showHeader" class="header">
      {{ header.title }}
    </div>
    <div class="data">
      <oxd-text v-if="hasLocation" tag="p">
        <a :href="mapUrl" target="_blank" rel="noopener noreferrer" @click.stop>
          {{ latitude }}, {{ longitude }}
        </a>
        <oxd-text v-if="accuracy !== null" tag="span" class="accuracy">
          ±{{ accuracy }} m
        </oxd-text>
      </oxd-text>
      <oxd-text v-else tag="p" class="accuracy">No location</oxd-text>
    </div>
  </div>
</template>

<script>
import {useInjectTableProps} from '@ohrm/oxd';

export default {
  name: 'LocationCell',

  props: {
    header: {
      type: Object,
      required: true,
    },
    latitude: {
      type: [String, Number],
      default: null,
    },
    longitude: {
      type: [String, Number],
      default: null,
    },
    accuracy: {
      type: [String, Number],
      default: null,
    },
  },

  setup() {
    const {screenState} = useInjectTableProps();
    return {screenState};
  },

  computed: {
    hasLocation() {
      return this.latitude !== null && this.longitude !== null;
    },
    mapUrl() {
      return `https://www.google.com/maps?q=${this.latitude},${this.longitude}`;
    },
    showHeader() {
      return !(
        this.screenState.screenType === 'lg' ||
        this.screenState.screenType === 'xl'
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.oxd-table-card-cell {
  display: block;
  & .header {
    font-weight: 700;
  }
  & .accuracy {
    color: $oxd-interface-gray-color;
    white-space: nowrap;
    margin-left: 0.25rem;
  }
}
</style>
